export const CAROUSEL_INFO_VALUES = [
  {
    title: 'Why join Awign?',
    details: 'Enjoy the best in industry earnings, freedom to choose the projects based on your interest and higher tax saving opportunity with Awign Expert',
    img: '/images/login/why-awign-1.svg'
  },
  {
    title: 'Project Based Opportunities',
    details: 'Explore a wide range of project-based contract opportunities to enhance your career growth and professional development.',
    img: '/images/login/project-based-opportunity.svg'
  },
  {
    title: 'Refer and Earn',
    details: 'Invite others and earn rewards through our referral program. Spread the word and reap the benefits!',
    img: '/images/login/refer-and-earn.svg'
  }
];

// different status for the flow of login page

export const FORM_STATUS = {
  SIGNUP: 0,
  VERIFY_OTP: 1,
  CONTINUE_PAGE: 2,
  ADMIN_ERROR: 3
};
